import { Box } from '@mui/material';
import styled from 'styled-components';

const StyledEmptyVoices = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: calc(100vh - 310px);

  .empty-voice-image {
    width: 150px;
    height: 150px;
  }
`;

export { StyledEmptyVoices };
